import React from "react"
import { Stack, Icon, DefaultButton, TextField, Separator } from '@fluentui/react';
import { paneFooterStyles, paneFooterTokens, footerMainTextStyle, textFieldStyles, copyLinkButtonStyle, copyIconStyle } from "./styles/CommandPanel.styles"
import Tooltip from '@material-ui/core/Tooltip';
const invitePeopleString = 'Share this link to invite additional attendees';
const copyJoinInfoString = 'Copy join info';

const copyJoinLink = () => {
  const inputElement = document.getElementById('inputText') as HTMLInputElement;
  inputElement.select();
  document.execCommand('copy');
};

const getMeetingLink = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('meetingId');
};

export const Footer = () => {
  return <Stack styles={paneFooterStyles} tokens={paneFooterTokens}>
    <Separator />
    <div className={footerMainTextStyle}>{invitePeopleString}</div>
    <div className="inputtextfp1">
      <div className="inputtextfp2">
        <TextField styles={textFieldStyles} id="inputText" type="text"
          value={`${window.location.href.split('?')[0] + '?meetingId=' + getMeetingLink()}`}
        // value={sessionStorage.getItem('originURL') + '?meetingId=' + getMeetingLink()}
        // value={`${document.baseURI}`}
        ></TextField>
      </div>
      <div className="inputtextfp3">
        <DefaultButton style={{ backgroundColor: '#009C9D', color: '#fff', border: '1px solid #009c9d', borderRadius: '4px', }} className={copyLinkButtonStyle} onClick={copyJoinLink}>
          <Tooltip title={copyJoinInfoString} placement="top-start"><Icon iconName="Copy" className={copyIconStyle} /></Tooltip>
          {/* {copyJoinInfoString} */}
        </DefaultButton>
      </div>
    </div>
  </Stack>
}